<template>
<div class="find">
	<div class="input-group">
		<div class="text-busca" v-html="textRight"></div>
		<fa-icon icon="search" class="icone-busca-texto" />
		<input type="text" style="padding-left:36px; border-radius:30px"
				:placeholder="placeholder"
				:disabled="disabled"
				@keyup="$emit('key-up', busca)"
				@keyup.enter="$emit('keyup-enter', busca)" v-model="busca" class="form-control form-control-sm">
	</div>
</div>
</template>

<script>
export default {

	props: {
		disabled: {
			type:  Boolean,
			require: false,
			default: false
		},

		textRight: {
			type: String,
			require: false,
			default: ""
		},

		placeholder: {
			type: String,
			require: false,
			default: ""
		}
	},

	data () {
		return {
			busca: ''
		}
	}
}
</script>

<style lang="scss" scoped>

.find {

	.icone-busca {
		position: absolute;
		top: 8px;
		left: 10px;
		color: #999;
		z-index: 9;
	}
	.text-busca {
		position: absolute;
		right: 22px;
		top: 4px;
		color: #999;
		z-index: 10;
	}

	.icone-busca-texto {
		position: absolute;
		top: 8px;
		left: 10px;
		color: #999;
		z-index: 11;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/find/main.vue